import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import TickIcon from "./Icons/Tick";
import styled, { css } from "styled-components";
import { HtmlContent } from "./Content";

const SafesitePromiseStyles = styled.div`
  ${({ ...props }) => css`
    background: ${props.theme.colors.lightPrimary};
    padding: 24px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;

    h2 {
      margin-bottom: 16px;
    }

    p {
      margin-bottom: 24px;
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      padding: 32px;

      p {
        margin: 0;
      }
    }
  `}
`;
const TickListStyles = styled.ul`
  ${({ ...props }) => css`
    margin-top: 16px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    li {
      display: flex;
      font-size: 1rem;

      & + li {
        margin-top: 8px;
      }

      svg {
        margin-right: 12px;
        flex-shrink: 0;
        color: ${props.theme.colors.primary};
      }
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      margin-top: 32px;
      li {
        & + li {
          margin-top: 16px;
        }
      }
    }
  `}
`;

export const SafesitePromise = () => {
  let data = {
    wp: {
      siteSettings: {
        siteSettings: {
          safesitePromiseIntroCopy: 'We are sure that you will be happy with our services, but if for any reason you are not, we will be sure to make it right for no extra cost!',
          safesitePromiseUsps: [
            {
              safesitePromiseUsp: 'Nationwide coverage',
            },
            {
              safesitePromiseUsp: 'Completely free, no-obligation quotes',
            },
            {
              safesitePromiseUsp: 'The most competitive pricing',
            },
            {
              safesitePromiseUsp: 'Industry-leading reputation & accreditations',
            }
          ]
        }
      }
    }
  }
  if (!process.env.STORYBOOK) {
    data = useStaticQuery(graphql`
      query SafesitePromiseQuery {
        wp {
          siteSettings {
            siteSettings {
              safesitePromiseIntroCopy
              safesitePromiseUsps {
                safesitePromiseUsp
              }
            }
          }
        }
      }
    `);
  }

  return (
    <SafesitePromiseStyles>
      <h2>The SafeSite promise</h2>
      <p>{data.wp.siteSettings.siteSettings.safesitePromiseIntroCopy}</p>
      {data.wp.siteSettings.siteSettings.safesitePromiseUsps.length > 0 && (
        <TickListStyles>
          {data.wp.siteSettings.siteSettings.safesitePromiseUsps.map(
            (usp, index) => {
              return (
                <li key={index}>
                  <TickIcon />
                  <span><HtmlContent htmlString={usp.safesitePromiseUsp} /></span>
                </li>
              );
            }
          )}
        </TickListStyles>
      )}
    </SafesitePromiseStyles>
  );
};
